module.exports = __webpack_public_path__ + "img/enceladus.96231acd.png";